import { Controller } from "stimulus";
import "@selectize/selectize";

export default class extends Controller {
  connect() {
    const plugins = ["silent_remove"];
    const conditionalOptions = {};

    const isMulti = this.element.attributes.multiple;
    const inModal = $(this.element).parents(".modal").length > 0;
    const addSingle = this.element.attributes.selectizeAddSingle;
    const addMulti = $(this.element).data("tags");
    const searchUrl = $(this.element).data("search-url");

    if (isMulti) {
      plugins.push("remove_button");
    }

    const repositionCallback = inModal ? this.buildDropdownRepositionCallback() : null;

    if (addSingle || addMulti) {
      conditionalOptions.create = true;

      conditionalOptions.createFilter = function (input) {
        return Object.values(this.options).every(
          option =>
            option.text.toLowerCase() !== input.toLowerCase() &&
            option.value.toLowerCase() !== input.toLowerCase(),
        );
      };
    }

    if (addMulti) {
      conditionalOptions.onItemAdd = function (value, item) {
        if (value.length === 0 && isMulti) {
          this.removeItem(item, true);
        }
      };
    }

    if (searchUrl) {
      conditionalOptions.searchField = ["text", "name", "value"];
      // eslint-disable-next-line consistent-return
      conditionalOptions.load = function (query, callback) {
        if (!query.length) return callback();
        $.ajax({
          url: `${searchUrl}?q=${encodeURIComponent(query)}`,
          type: "GET",
          error: () => callback(),
          success: response => callback(response.results),
        });
      };
      conditionalOptions.render = {
        option(item) {
          if (item.name) {
            const employer = item.employer ? ` — ${item.employer}` : "";

            return `<div class="option flex flex-col px-4 py-1">
              <div class="font-semibold">${item.name}</div>
              <div class="text-sm text-gray-500">${item.value}${employer}</div>
            </div>`;
          }
          return `<div class="option">${item.text}</div>`;
        },
      };
    }

    $(this.element)
      .selectize({
        width: "100%",
        plugins,
        placeholder: $(this.element).data("placeholder"),
        openOnFocus: true,
        closeAfterSelect: true,
        allowEmptyOption: true,
        respect_word_boundaries: false,
        selectOnTab: true,
        maxOptions: searchUrl ? null : this.element.length,
        onFocus() {
          if (this.getValue().length === 0) {
            this.clear();
          }
        },
        onDropdownOpen($dropdown) {
          document.querySelectorAll("[data-controller='select']").forEach(el => {
            if (el !== this.$input[0] && el.selectize) {
              el.selectize.close();
            }
          });
          if (repositionCallback) {
            repositionCallback($dropdown);
          }
        },
        ...conditionalOptions,
      })
      .on("change", () => this.element.dispatchEvent(new Event("scoutchange", { bubbles: true })));

    document.addEventListener(
      "turbolinks:before-cache",
      () => {
        this.teardown();
      },
      { once: true },
    );

    if (this.element.title) {
      $(this.element).siblings(".selectize-control").attr("title", this.element.title);
    }
  }

  teardown() {
    this.element?.selectize?.destroy();
  }

  buildDropdownRepositionCallback() {
    return $dropdown => {
      const dropdownPosition = $dropdown[0].getBoundingClientRect();
      const dropdownSpillover = dropdownPosition.bottom - $(window).height();

      if (dropdownSpillover > 0) {
        $dropdown.css("top", dropdownPosition.top - dropdownSpillover);
      }
    };
  }
}
